;(function () {
  if (typeof EmblaCarousel === 'undefined') {
    console.error('[Embla] EmblaCarousel is undefined - CDN script may not have loaded');
    return;
  }

  const defaults = {
    align: 'start',
    loop: false,
    watchDrag: true,
    dragFree: false,
    containScroll: 'trimSnaps',
    slidesToScroll: 1,
    inViewThreshold: 0,
    skipSnaps: false,
    breakpoints: undefined,
  };

  const parseJson = (value, fallback) => {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  };

  // Expose initEmbla globally for dynamic content (e.g., product recommendations)
  window.initEmbla = function(root) {
    const viewport = root.querySelector('[data-embla-viewport]');
    const container = root.querySelector('[data-embla-container]');
    
    if (!viewport || !container) {
      console.warn('[Embla] Missing viewport or container');
      return;
    }

    const slides = container.querySelectorAll('.embla__slide');
    
    if (!slides.length) {
      console.warn('[Embla] No slides found');
      return;
    }

    // Build options from data attributes
    const options = Object.assign(
      {},
      defaults,
      parseJson(root.getAttribute('data-embla-options'), {})
    );

    // Handle individual data attributes for options
    if (root.hasAttribute('data-embla-loop')) {
      options.loop = root.getAttribute('data-embla-loop') === 'true';
    }
    if (root.hasAttribute('data-embla-align')) {
      options.align = root.getAttribute('data-embla-align');
    }
    if (root.hasAttribute('data-embla-drag-free')) {
      options.dragFree = root.getAttribute('data-embla-drag-free') === 'true';
    }

    // Handle autoplay - support both JSON object and simple boolean
    let autoplayPlugin;
    const autoplayAttr = root.getAttribute('data-embla-autoplay');
    if (autoplayAttr && typeof EmblaCarouselAutoplay !== 'undefined') {
      let autoplayOpts = parseJson(autoplayAttr, null);
      
      // If it's a simple "true" string, build autoplay options from individual attributes
      if (autoplayAttr === 'true' || autoplayOpts === null) {
        const delay = parseInt(root.getAttribute('data-embla-autoplay-delay')) || 3000;
        const stopOnInteraction = root.getAttribute('data-embla-autoplay-stop') !== 'false';
        autoplayOpts = { delay, stopOnInteraction };
      }
      
      autoplayPlugin = EmblaCarouselAutoplay(autoplayOpts);
    }

    const embla = EmblaCarousel(viewport, options, autoplayPlugin ? [autoplayPlugin] : undefined);

    const prevSelector = root.getAttribute('data-embla-prev');
    const nextSelector = root.getAttribute('data-embla-next');
    const dotsSelector = root.getAttribute('data-embla-dots');
    const prevBtn = prevSelector ? document.querySelector(prevSelector) : null;
    const nextBtn = nextSelector ? document.querySelector(nextSelector) : null;
    const dotsRoot = dotsSelector ? document.querySelector(dotsSelector) : null;
    if (prevBtn) prevBtn.addEventListener('click', embla.scrollPrev, { passive: true });
    if (nextBtn) nextBtn.addEventListener('click', embla.scrollNext, { passive: true });

    // Update navigation arrows visibility based on scroll position and slide count
    const updateNavButtons = () => {
      // Determine how many slides per view need to be visible for next arrow to be enabled
      let slidesPerView = 1;
      
      // Attempt to get from options or from root vars (if using breakpoints via CSS vars, etc.)
      if (options && typeof options.slidesToScroll === 'number') {
        slidesPerView = options.slidesToScroll;
      }
      // If Embla has a method for slidesInView, use its length (for situations like responsive/multi-row)
      if (typeof embla.slidesInView === 'function') {
        slidesPerView = Math.max(embla.slidesInView().length, slidesPerView);
      }
      const totalSlides = embla.slideNodes().length;
      if (prevBtn) {
        prevBtn.disabled = !embla.canScrollPrev();
        prevBtn.classList.toggle('is-disabled', !embla.canScrollPrev());
      }

      if (nextBtn) {
        // Determine disable state for next:
        // - If can't scroll next
        // - Or there's no more slides available (all visible)
        // - Or slides are less than or equal to slidesPerView
        const canScrollNext = embla.canScrollNext();
        const atEnd = !canScrollNext;
        const notEnoughSlides = totalSlides <= slidesPerView;

        const shouldDisableNext = atEnd || notEnoughSlides;

        nextBtn.disabled = shouldDisableNext;
        nextBtn.classList.toggle('is-disabled', shouldDisableNext);
      }
    };

    // Listen to all events that may require updating nav buttons
    if (prevBtn || nextBtn) {
      ['select', 'reInit', 'settle', 'scroll'].forEach(evt =>
        embla.on(evt, updateNavButtons)
      );
      updateNavButtons(); // Initial state
    }

    if (dotsRoot) {
      if (!dotsRoot.children.length) {
        const slidesCount = embla.slideNodes().length;
        const frag = document.createDocumentFragment();
        for (let i = 0; i < slidesCount; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'swiper-pagination-bullet';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          frag.appendChild(dot);
        }
        dotsRoot.appendChild(frag);
      }
      const dots = Array.from(dotsRoot.children || []);
      const updateDots = () => {
        const selected = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === selected);
          dot.classList.toggle('swiper-pagination-bullet-active', index === selected);
        });
      };
      dots.forEach((dot, index) =>
        dot.addEventListener('click', () => embla.scrollTo(index), { passive: true })
      );
      embla.on('select', updateDots);
      embla.on('reInit', updateDots);
      updateDots();
    }

    // Handle scrollbar
    const scrollbarSelector = root.getAttribute('data-embla-scrollbar');
    const scrollbarRoot = scrollbarSelector ? document.querySelector(scrollbarSelector) : null;

    if (scrollbarRoot) {
      // Create scrollbar drag element if not exists
      let scrollbarDrag = scrollbarRoot.querySelector('.swiper-scrollbar-drag');
      if (!scrollbarDrag) {
        scrollbarDrag = document.createElement('div');
        scrollbarDrag.className = 'swiper-scrollbar-drag';
        scrollbarRoot.appendChild(scrollbarDrag);
      }

      const updateScrollbar = () => {
        const scrollProgress = embla.scrollProgress();
        const slidesInView = embla.slidesInView().length;
        const totalSlides = embla.slideNodes().length;
        const dragWidth = Math.max((slidesInView / totalSlides) * 100, 10);
        const translateX = scrollProgress * (100 - dragWidth);
        
        scrollbarDrag.style.width = `${dragWidth}%`;
        scrollbarDrag.style.transform = `translateX(${translateX / (dragWidth / 100)}%)`;
      };

      embla.on('scroll', updateScrollbar);
      embla.on('reInit', updateScrollbar);
      updateScrollbar();

      // Make scrollbar draggable
      let isDragging = false;
      let startX = 0;
      let startProgress = 0;

      scrollbarRoot.addEventListener('pointerdown', (e) => {
        isDragging = true;
        startX = e.clientX;
        startProgress = embla.scrollProgress();
        scrollbarRoot.setPointerCapture(e.pointerId);
      });

      scrollbarRoot.addEventListener('pointermove', (e) => {
        if (!isDragging) return;
        const rect = scrollbarRoot.getBoundingClientRect();
        const deltaX = e.clientX - startX;
        const deltaProgress = deltaX / rect.width;
        const newProgress = Math.max(0, Math.min(1, startProgress + deltaProgress));
        embla.scrollTo(Math.round(newProgress * (embla.scrollSnapList().length - 1)));
      });

      scrollbarRoot.addEventListener('pointerup', () => {
        isDragging = false;
      });
    }

    // Expose for debugging
    root.embla = embla;
  };

  const initAll = () => {
    const emblaNodes = document.querySelectorAll('[data-embla]');
    
    // Immediately initialize hero slider (above the fold)
    const heroSlider = document.querySelector('.header-slider[data-embla]');
    if (heroSlider) {
      window.initEmbla(heroSlider);
    }
    
    // Lazy initialize other sliders when they come into view
    const otherSliders = Array.from(emblaNodes).filter(node => node !== heroSlider);
    
    if (otherSliders.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.embla) {
            window.initEmbla(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      
      otherSliders.forEach(node => observer.observe(node));
    } else {
      // Fallback: initialize all immediately if no IntersectionObserver
      otherSliders.forEach(node => window.initEmbla(node));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

